<template>
    <div style="background: #fff;margin:10px;padding: 30px 40px;box-sizing: border-box;height: 100%;overflow: auto" v-loading="loading">
      <div v-for="(item,index) in questList">
          <p class="major">{{numberToChineseDigits(index+1)}} 、{{item.title}}(共{{item.dataList.length}}题，每题{{item.question_scores}}分，共{{item.total_score}}分)</p>
        <div v-for="(que ,index) in item.dataList">
          <div>
            <span class="title" >{{index +1}}.{{que.title}}</span>
          </div>
          <div>
           <div v-if="[2001,2002,2003].includes(que.question_type)" v-for="it in que.option_text.split(',')">
          <span style="padding-left:20px;" class="answer" v-if="it">{{it.replace(':', ' ')}}</span>
        </div>
            <div v-if="[2005].includes(que.question_type)">
              <el-input type="textarea"></el-input>
            </div>
          </div>
        </div>
      </div>
      <div style="text-align: center;margin-top: 20px;">
        <el-button @click="handleCancel" style="background-color: #347CAF;color:#fff">返回上一页</el-button>
      </div>
    </div>
</template>
<script>
export default {
  name: "previewExam",
  data() {
    return {
      loading : false,
      questList: [],
      typeList: [],
      resultList: []
    }
  },

  created() {
    this.loading = true
    setTimeout(() => {
      this.loading = false
    },2000)
    this.questList = []
    // setTimeout(() => {
      const dataStr = sessionStorage.getItem('selectedList');
      if (dataStr) {
        this.questList  = JSON.parse(dataStr);
        // 使用 data
        // 可选：用完删除
        // sessionStorage.removeItem('selectedList');
      }
      const dataStr2 = sessionStorage.getItem('ruleList');
      if (dataStr2) {
        let resData = this.questList ;
        let ruleList = JSON.parse(dataStr2);
        // 遍历 redData，为每个分组匹配 ruleList 并计算
        resData.forEach(group => {
          // 在 ruleList 中查找匹配的规则
          const rule = ruleList.find(r => r.question_type === group.id);

          if (rule) {
            // 转换分数为数字
            const scorePerQuestion = parseFloat(rule.question_scores);
            const questionCount = group.dataList.length; // 实际题目数量

            // 添加字段到 redData 项
            group.question_scores = scorePerQuestion;
            group.total_score = scorePerQuestion * questionCount; // 总分
          } else {
            // 如果没找到规则，可设默认值或留空
            group.question_scores = 0;
            group.total_score = 0;
          }
        });
      }

    // },)
  },
  methods: {
    numberToChineseDigits(str) {
      const map = {
        '0': '零',
        '1': '一',
        '2': '二',
        '3': '三',
        '4': '四',
        '5': '五',
        '6': '六',
        '7': '七',
        '8': '八',
        '9': '九'
      };

      return String(str)
          .split('')
          .map(char => map[char] || char) // 如果不是数字，保留原字符
          .join('');
    },
    handleCancel(){
      this.$router.push({path:'/cloudTraining/exam/updateExam',query:{id:this.$route.query.id,isPreviewBack:1}})
    }

  },


}
</script>
<style scoped lang="scss">
.major{
  font-size: 16px;
  font-weight: bold;
  line-height: 40px;
}
.title,.answer{
  font-size: 14px;
  line-height: 32px;
}
</style>